import {
  FileText, AlertCircle, Send, Clock, CheckCircle,
  XCircle, RefreshCw
} from 'lucide-react';

export const STATUS_CONFIG = {
  DRAFT: { color: 'slate', label: 'Draft', icon: FileText },
  PENDING_AUTHORIZATION: { color: 'amber', label: 'Needs Authorization', icon: AlertCircle },
  READY_TO_SEND: { color: 'blue', label: 'Ready to Send', icon: Send },
  SENT: { color: 'indigo', label: 'Sent', icon: Clock },
  ACKNOWLEDGED: { color: 'purple', label: 'Acknowledged', icon: CheckCircle },
  IN_PROGRESS: { color: 'cyan', label: 'In Progress', icon: RefreshCw },
  RECEIVED: { color: 'green', label: 'Records Received', icon: CheckCircle },
  PARTIALLY_RECEIVED: { color: 'emerald', label: 'Partially Received', icon: CheckCircle },
  DENIED: { color: 'red', label: 'Denied', icon: XCircle },
  CANCELLED: { color: 'gray', label: 'Cancelled', icon: XCircle }
};

export const STATUS_COLOR_CLASSES = {
  slate: { bg: 'bg-slate-100', text: 'text-slate-600', badge: 'bg-slate-100 text-slate-700' },
  amber: { bg: 'bg-amber-100', text: 'text-amber-600', badge: 'bg-amber-100 text-amber-700' },
  blue: { bg: 'bg-blue-100', text: 'text-blue-600', badge: 'bg-blue-100 text-blue-700' },
  indigo: { bg: 'bg-indigo-100', text: 'text-indigo-600', badge: 'bg-indigo-100 text-indigo-700' },
  purple: { bg: 'bg-purple-100', text: 'text-purple-600', badge: 'bg-purple-100 text-purple-700' },
  cyan: { bg: 'bg-cyan-100', text: 'text-cyan-600', badge: 'bg-cyan-100 text-cyan-700' },
  green: { bg: 'bg-green-100', text: 'text-green-600', badge: 'bg-green-100 text-green-700' },
  emerald: { bg: 'bg-emerald-100', text: 'text-emerald-600', badge: 'bg-emerald-100 text-emerald-700' },
  red: { bg: 'bg-red-100', text: 'text-red-600', badge: 'bg-red-100 text-red-700' },
  gray: { bg: 'bg-gray-100', text: 'text-gray-600', badge: 'bg-gray-100 text-gray-700' }
};

export const RECORD_TYPES = [
  { value: 'LAB_RESULTS', label: 'Lab Results' },
  { value: 'IMAGING', label: 'Imaging/Radiology' },
  { value: 'CONSULTATION', label: 'Office Visit Notes' },
  { value: 'PRESCRIPTIONS', label: 'Prescriptions' },
  { value: 'IMMUNIZATIONS', label: 'Immunization Records' },
  { value: 'SURGICAL', label: 'Surgical/Procedure Records' },
  { value: 'DISCHARGE', label: 'Discharge Summary' },
  { value: 'COMPLETE', label: 'Complete Medical Record' },
  { value: 'OTHER', label: 'Other' }
];

export const RECORD_TYPE_LABELS = RECORD_TYPES.reduce((acc, { value, label }) => {
  acc[value] = label;
  return acc;
}, {});

export const URGENCY_OPTIONS = [
  { value: 'routine', label: 'Routine (2-4 weeks)' },
  { value: 'urgent', label: 'Urgent (1 week)' },
  { value: 'stat', label: 'STAT (24-48 hours)' }
];

export {
  FileText, AlertCircle, Send, Clock, CheckCircle,
  XCircle, RefreshCw
};
